import React from 'react';

import * as S from './styles';
import { ItemDynamicPageInPhone } from 'types/ItemDynamicPageInPhone';
import WaitingForDataDynamicPage from 'components/WaitingForDataDynamicPage';
interface HighlightBarProps {
	item: ItemDynamicPageInPhone;
}

//esse componente é igual em todos os tipos de loja
export default function HighlightBar({ item }: HighlightBarProps) {
	return (
		<S.container>
			{Object.keys(item.data).length === 0 ? (
				<WaitingForDataDynamicPage />
			) : (
				<S.box
					$backgroundColor={item?.data?.backgroundColor || '#FFF'}
					$textColor={item?.data?.textColor || '#000'}
				>
					<p>{item?.data?.text || 'Não há texto'}</p>
				</S.box>
			)}
		</S.container>
	);
}
